import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { variables } from "../utility/variables";
import { useUser } from "../contexts/UserContext";
import { useMsal } from '@azure/msal-react';
import { useNavigate, useLocation } from 'react-router-dom';

const Agreements = () => {
  const { user } = useUser();
  const { instance } = useMsal();
  const [agrList, setAgrList] = useState([]);

  const [agrListFiltered, setAgrListFiltered] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    refreshList();
  }, []);

  const refreshList = async () => {
    // // step 1: if no active account, re-direct to sign in page
    // const userActiveAccount = await instance.getActiveAccount();
    // if(!userActiveAccount){
    //   navigate('/signin');
    // }
    // const userEmail = userActiveAccount.username;
    // // step 2: get access token
    // const tokenResponse = await instance.acquireTokenSilent({
    //   scopes: [`api://${process.env.REACT_APP_ROSTER_CLIENTID}/access_as_user`],
    //   account: userActiveAccount,
    // });
    // const accesstoken = tokenResponse.accessToken;
    // step 3: call api, validate user
    const response = await fetch(variables.API_URL + `User/validateuser`, {
      method: "GET",
      mode: "cors",
      credentials: "include", // important to send/set cookies
    });
    if (response.status === 401) {
      // Handle unauthorized
      console.log('Agreements.js: Unauthorized or session expired: Redirect to login');
      alert('Unauthorized or session expired: Redirect to login');
      navigate('/signin');
    }
    const data = await response.json();
    if (data && data[0]) {
      console.log('User is authorized', data);
    } else {
      // console.error(`User "${userEmail}" not authorized. Logging out...`);
      // alert(`Email "${userEmail}" is not recognized. Please request access. Logging out...`);
      instance.logoutRedirect(); // Log out unauthorized users
    }  
    // step 4: fetch agreement list using api call
    fetch(variables.API_URL + `Agreement/GetAgreements`, {
      method: "GET",
      mode: "cors",
      credentials: "include", // important to send/set cookies
    })
    .then(response => response.json())
    .then(data => {
      setAgrList(data);
      setAgrListFiltered(data);
    });
  }

  const filterList = (e) => {
    const input = e.target;
    const filtered = agrList.filter(a => {
      if (input.value === '') {
        return true;
      }
      if (input.name === 'AgrPO') {
        return (
          a['AgreementNumber'].trim().toLowerCase().includes(input.value.trim().toLowerCase()) 
          || (a['PONumber'] ?? '').trim().toLowerCase().includes(input.value.trim().toLowerCase())
          || (a['annualAgrNumber'] ?? '').trim().toLowerCase().includes(input.value.trim().toLowerCase())
        )
      }
      return a[input.name]?.trim().toLowerCase().includes(input.value.trim().toLowerCase());
    });
    setAgrListFiltered(filtered);
  }

  return (
    <div className="m-20">
      <div className='p-3 w-1/2 bg-slate-100 rounded'>
        <h4 className="text-xl mb-5">Agreement Search</h4>
        <div className='flex flex-col gap-2'>
            <div className='flex flex-row w-full align-middle'>
                <h6 className='w-1/3'>Agreement Number</h6>
                <input id='AgreementFilter_AgrPO' name='AgrPO' onChange={filterList} className='w-2/3 p-2 border rounded-xl' type='text' placeholder="Partial values accepted"/>
            </div>
            <div className='flex flex-row w-full align-middle'>
                <h6 className='w-1/3'>Agreement Title</h6>
                <input id='AgreementFilter_AgrTitle' name='AgreementTitle'  onChange={filterList} className='w-2/3 p-2 border rounded-xl' type='text' placeholder="Partial values accepted"/>
            </div>
            <div className='flex flex-row w-full align-middle'>
                <h6 className='w-1/3'>PA APM</h6>
                <input id='AgreementFilter_PAAPM' name='PA_APM_Name' onChange={filterList} className='w-2/3 p-2 border rounded-xl' type='text' placeholder="Partial values accepted"/>
            </div>
            <div className='flex flex-row w-full align-middle'>
                <h6 className='w-1/3'>PA DAR</h6>
                <input id='AgreementFilter_PADAR' name='PA_DAR_Name' onChange={filterList} className='w-2/3 p-2 border rounded-xl' type='text' placeholder="Partial values accepted"/>
            </div>
        </div>
      </div>
      <br />
      <br />
      <div className='flex flex-col justify-start w-full rounded'>
          <h5 className="text-xl mb-5 pl-4">Agreements</h5>
          <table id='AgreementsSearchResults' className='table table-auto border rounded p-5 overflow-y-scroll max-h-96'>
            <thead className="border rounded p-5 text-left">
              <tr className='p-4 bg-blue-200'>
                <th className='p-4 w-64'>Agreement # / PO</th>
                <th className='p-4 w-1/3'>Agreement Title</th>
                <th className='p-4 w-1/3'>Vendor Name</th>
                <th className='p-4'>PA APM</th>
                <th className='p-4'>PA DAR</th>
                <th className='p-4'>Roster History</th>
                <th className='p-4'>Last Roster Status</th>
                <th className='p-4'>Primary Contact</th>
                <th className='p-4'>Contact Email</th>
              </tr>
            </thead>
            <tbody>
              {
                agrListFiltered.map(item => {
                    return (
                      <tr key={item.ManagementId} className="odd:bg-gray-100" >
                          <td className='p-4 font-bold'>
                            {item.AgreementNumber + (item.annualAgrNumber ? ', ' + item.annualAgrNumber : '')}
                            <span className={!item.PONumber ? 'invisible' : 'visible block'}>PO {item.PONumber}</span>
                          </td>
                          <td className='p-4'>{item.AgreementTitle}</td>
                          <td className='p-4'>{item.VendorName}</td>
                          <td className='p-4'>{item.PA_APM_Name}</td>
                          <td className='p-4'>{item.PA_DAR_Name}</td>
                          <td className='p-4'>
                            <Link to={`/roster/${item.ManagementId}`} className='underline font-bold text-blue-600' state={{agr: item}}>
                              {'View'}
                            </Link>
                          </td>
                          <td className='p-4'>
                              {item.LastRosterStatus}
                          </td>
                          <td className='p-4'>{item.AgrManager}</td>
                          <td className='p-4'>{item.ContactEmail}</td>
                      </tr>
                    );
                })
              }
            </tbody>
          </table>
        </div>
    </div>

  )
}


export default Agreements